<template>
<div class="ui-body">
        <!-- 01.主体容器 - 头部 Start -->
        <div class="ui-container-header">
            <!-- 01.01.主体容器 - 头部 - 标题 Start -->
            <h3 class="ui-container-header-title"><i class="ion-ios-arrow-forward"></i>{{ this.$route.meta.title }}</h3>
            <!-- 01.01.主体容器 - 头部 - 标题 End -->
            <!-- 01.02.主体容器 - 头部 - 副标题 Start -->
            <p class="ui-container-header-subtitle">{{ this.$route.meta.description }}</p>
            <!-- 01.02.主体容器 - 头部 - 副标题 End -->
            <!-- 01.03.主体容器 - 头部 - 按钮组 Start -->
            <div class="ui-container-header-group" v-if="$Permissions(['BasicsOperation'])">
                <el-button-group>
                    <el-button @click="operateAllCreate" v-if="$Permissions(['BasicsOperationCreate'])"><i class="ion-ios-add-circle"></i>新增</el-button>
                    <el-button @click="operateAllUpload" v-if="$Permissions(['BasicsOperationUpload'])"><i class="ion-ios-cloud-upload"></i>导入</el-button>
                    <el-dropdown @command="operateAllDownload" v-if="$Permissions(['BasicsOperationDownload'])">
                        <el-button><i class="ion-ios-cloud-download"></i>导出<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="all" v-if="$Permissions(['BasicsOperationDownloadAll'])">导出全部</el-dropdown-item>
                            <el-dropdown-item command="part" v-if="$Permissions(['BasicsOperationDownloadSelected'])">导出所选</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown @command="operateAllState" v-if="$Permissions(['BasicsOperationState'])">
                        <el-button><i class="ion-ios-switch"></i>审核<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="adopt" v-if="$Permissions(['BasicsOperationStateOn'])">批量审核</el-dropdown-item>
                            <el-dropdown-item command="failed" v-if="$Permissions(['BasicsOperationStateOff'])">批量反审</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button @click="operateAllDelete" v-if="$Permissions(['BasicsOperationDelete'])"><i class="ion-ios-close-circle"></i>删除</el-button>
                    <el-button @click="operateAllRefresh" v-if="$Permissions(['BasicsOperationRefresh'])"><i class="ion-ios-refresh-circle"></i>刷新</el-button>
                </el-button-group>
            </div>
            <!-- 01.03.主体容器 - 头部 - 按钮组 End -->
        </div>
        <!-- 01.主体容器 - 头部 End -->

        <!-- 02.主体容器 - 内容 Start -->
        <div class="ui-container-content">
            <div class="ui-content">
                <!-- 02.01.主体容器 - 内容 - 搜索 Start -->
                <div class="ui-container-search">
                    <div class="ui-search-quick" v-if="$Permissions(['BasicsSearch'])">
                        <!-- 02.01.01.快捷搜索 Start -->
                        <div class="ui-search-quick-input" v-if="$Permissions(['BasicsSearchQuick'])">
                            <el-input placeholder="请输入字典编码 / 字典标题 ..." v-model="quickSearch" class="input-with-select">
                                <el-button type="primary" slot="append" icon="el-icon-search" @click="clickQuickSearch"></el-button>
                            </el-input>
                        </div>
                        <!-- 02.01.01.快捷搜索 End -->
                        <!-- 02.01.02.更多搜索切换 Start -->
                        <div class="ui-search-quick-button" v-if="$Permissions(['BasicsSearchMore'])">
                            <el-button @click="searchState=!searchState">更多查询<i :class="searchState?'el-icon-arrow-up':'el-icon-arrow-down'"></i></el-button>
                        </div>
                        <!-- 02.01.02.更多搜索切换 End -->
                    </div>
                    <!-- 02.01.04.更多搜索表单 Start -->
                    <el-collapse-transition>
                        <div class="ui-search-more" v-show="searchState" v-if="$Permissions(['BasicsSearchMore'])">
                            <el-scrollbar>
                                <el-form ref="arraySearch" :model="arraySearch" :label-position="searchPosition">
                                    <el-row :gutter="30">
                                        <el-col :span="8">
                                            <el-form-item label="字典分类" prop="type">
                                                <el-select v-model="arraySearch.type" clearable placeholder="请选择审核状态">
                                                    <el-option label="分类级" value="1"></el-option>
                                                    <el-option label="数据级" value="2"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="16">
                                            <el-form-item label="上级字典" prop="parent">
                                                <el-cascader v-model="arraySearch.parent" :options="parentData" :props="{ checkStrictly: true }" placeholder="请选择上级组织" clearable></el-cascader>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="30">
                                        <el-col :span="8">
                                            <el-form-item label="字典编码" prop="code">
                                                <el-input v-model="arraySearch.code" placeholder="请输入字典编码"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="字典标题" prop="title">
                                                <el-input v-model="arraySearch.title" placeholder="请输入字典标题"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="审核状态" prop="state">
                                                <el-select v-model="arraySearch.state" clearable placeholder="请选择审核状态">
                                                    <el-option label="待审" value="0"></el-option>
                                                    <el-option label="通过" value="1"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </el-scrollbar>
                            <div class="ui-search-more-group">
                                <el-button type="primary" icon="ion-ios-search" @click="clickArraySearch">搜索</el-button>
                                <el-button icon="ion-ios-repeat" @click="resetArraySearch">重置</el-button>
                            </div>
                        </div>
                    </el-collapse-transition>
                    <!-- 02.01.04.更多搜索表单 End -->
                </div>
                <!-- 02.01.主体容器 - 内容 - 搜索 End -->
                <!-- 02.02.主体容器 - 内容 - 表格 Start -->
                <div class="ui-container-table" v-if="$Permissions(['BasicsTable'])">
                    <el-table :data="tableData" height="100%" @selection-change="operateSelection" v-loading="tableLoading">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="basics_class" label="字典分类" width="110">
                            <template #default="scope">
                                <div v-if="scope.row.basics_class === 1">
                                    <el-tag type="primary">分类级</el-tag>
                                </div>
                                <div v-if="scope.row.basics_class === 2">
                                    <el-tag type="success">数据级</el-tag>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="parent" label="上级字典" width="180"></el-table-column>
                        <el-table-column prop="code" label="字典编码" width="320" sortable></el-table-column>
                        <el-table-column prop="title" label="字典标题"></el-table-column>
                        <el-table-column prop="prefer" label="是否首选" width="100" v-if="$Permissions(['BasicsTablePrefer'])">
                            <template slot-scope="scope">
                                <el-switch v-if="scope.row.basics_class===2" v-model="scope.row.prefer" :active-value="true" :inactive-value="false" active-text inactive-text @change="operatePrefer($event,scope.row.id)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column prop="state" label="审核状态" width="100" v-if="$Permissions(['BasicsTableState'])">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.state" :active-value="true" :inactive-value="false" active-text inactive-text @change="operateState($event,scope.row.id)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="150" v-if="$Permissions(['BasicsTableOperation'])">
                            <template slot-scope="scope">
                                <el-button-group class="ui-table-button-group">
                                    <el-button size="mini" @click="operatePatch(scope.row.id)" v-if="$Permissions(['BasicsTableOperationPatch'])">编辑</el-button>
                                    <el-button size="mini" @click="operateDelete(scope.row.id)" v-if="$Permissions(['BasicsTableOperationDelete'])">删除</el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 02.02.主体容器 - 内容 - 表格 End -->
            </div>
        </div>
        <!-- 02.主体容器 - 内容 End -->

        <!-- 03.主体容器 - 尾部 Start -->
        <div class="ui-container-footer ">
            <!-- 03.02.主体容器 - 尾部 - 分页 Start -->
            <div class="ui-container-footer-pagination">
                <el-pagination background :current-page="tablePage" :page-sizes="pageSizes" :page-size="pageSize" :total="tableTotal" layout="sizes, prev, pager, next, jumper, total" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
            </div>
            <!-- 03.02.主体容器 - 尾部 - 分页 End -->
        </div>
        <!-- 03.主体容器 - 尾部 End -->

        <!-- 04.批量导入 Start -->
        <el-dialog class="ui-import" title="批量导入数据" :visible.sync="uploadDialog" width="60%" v-if="$Permissions(['BasicsOperationUpload'])">
            <Upload v-if="uploadDialog" a-title="系统字典信息表模板" a-template="/static/template/字典模板.xlsx" a-api="/api/upload/basics/"></Upload>
        </el-dialog>
        <!-- 04.批量导入 End -->
    </div>
</template>

<script>
    import Upload from "../common/upload"

    export default {
        name: "data_basics",
        components: {Upload},
        data() {
            return {
                // 02.数据搜索 ------------------------------------------------
                // 02.01.快捷搜索
                quickSearch: '',
                // 02.02.更多搜索
                arraySearch: {
                    parent: '',
                    title: '',
                    code: '',
                    state: ''
                },
                // 02.03.Search 显示状态
                searchState: false,
                // 02.04.Search 配置 - 标题位置
                searchPosition: 'top',
                // 02.05.Search 上级字典数据集
                parentData: [],
                // 03.数据数组 ------------------------------------------------
                // 03.01.数据数组 - 数据集
                tableData: [],
                // 03.02.数据数组 - 加载组件
                tableLoading: true,
                // 03.03.所选数据
                multipleTable: [],
                // 04.分页栏目 ------------------------------------------------
                // 04.01.分页栏目 - 当前页
                tablePage: 1,
                // 04.02.分页栏目 - 数据总量
                tableTotal: 400,
                // 04.03.分页栏目 - 每页数量条数
                pageSizes: [20, 50, 100, 200],
                // 04.04.分页栏目 - 分页条数
                pageSize: 20,
                // 05.数据上传/更新 ------------------------------------------------
                // 05.01.上传窗口状态
                uploadDialog: false,
            }
        },
        // 方法集合
        methods: {
            // 01.批量操作 ------------------------------------------------
            // 01.01.全选数据
            operateSelection(val) {
                this.multipleTable = []
                this.multipleSelection = val
                for (var i = 0; i < this.multipleSelection.length; i++) {
                    this.multipleTable.push(this.multipleSelection[i]['id'])
                }
            },
            // 01.02.新增
            operateAllCreate() {
                this.$router.replace('/manage/basics/add-basics')
            },
            // 01.03.批量导入
            operateAllUpload() {
                this.uploadDialog = true
                this.uploadSteps = 0
            },
            // 01.04.批量导出
            operateAllDownload(command) {
                // 01.04.01.导出全部
                if (command === 'all') {
                    this.$confirm('是否批量导出全部数据？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$api.get("/api/download/basics/").then((response) => {
                            this.$message.success(response.message)
                            window.open(this.$api_url + response.path)
                        })
                    }).catch(() => {

                    })
                }
                // 01.04.02.导出所选
                if (command === 'part') {
                    if (this.multipleTable.length === 0) {
                        this.$message.warning('请选择需要导出的数据')
                    } else {
                        this.$confirm('是否批量导出所选数据？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$api.get("/api/download/basics-active/", {'id': this.multipleTable}).then((response) => {
                                this.$message.success(response.message)
                                window.open(this.$api_url + response.path)
                            })
                        }).catch(() => {

                        })
                    }
                }
            },
            // 01.05.批量审核
            operateAllState(command) {
                // 01.05.01.批量审核
                if (command === 'adopt') {
                    if (this.multipleTable.length === 0) {
                        this.$message.warning('请选择需要审核的数据')
                    } else {
                        this.$confirm('是否批量审核所选数据？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$api.get('/api/state/basics-on/', {'id': this.multipleTable}).then((response) => {
                                this.$message.success(response)
                                this.operateAllRefresh()
                            })
                        }).catch(() => {

                        })
                    }
                }
                // 01.05.02.批量反审
                if (command === 'failed') {
                    if (this.multipleTable.length === 0) {
                        this.$message.warning('请选择需要反审的数据')
                    } else {
                        this.$confirm('是否批量反审所选数据？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$api.get('/api/state/basics-off/', {'id': this.multipleTable}).then((response) => {
                                this.$message.success(response)
                                this.operateAllRefresh()
                            })
                        }).catch(() => {

                        })
                    }
                }
            },
            // 01.06.批量删除
            operateAllDelete() {
                if (this.multipleTable.length === 0) {
                    this.$message.warning('请选择需要删除的数据')
                } else {
                    this.$confirm('是否批量删除所选数据？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$api.get('/api/delete/basics-active/', {'id': this.multipleTable}).then((response) => {
                            this.$message.success(response)
                            this.operateAllRefresh()
                        })
                    }).catch(() => {

                    })
                }
            },
            // 01.07.刷新
            operateAllRefresh() {
                this.getTableJson()
            },
            // 02.表格操作 ------------------------------------------------
            // 02.01.编辑
            operatePatch(value) {
                this.$router.replace('/manage/basics/patch-basics/' + value)
            },
            // 02.02.删除
            operateDelete(value) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.get('/api/delete/basics/', {'id': value}).then((response) => {
                        this.$message.success(response)
                        this.operateAllRefresh()
                    })
                }).catch(() => {

                })
            },
            // 02.03.审核
            operateState(event, value) {
                this.$api.get('/api/state/basics/', {'id': value, 'state': event}).then((response) => {
                    this.$message.success(response)
                    this.getTableJson()
                })
            },
            // 02.04.是否首选
            operatePrefer(event, value) {
                this.$api.get('/api/state/basics-prefer/', {'id': value, 'state': event}).then((response) => {
                    this.$message.success(response)
                    this.getTableJson()
                })
            },
            // 03.获取数据 ------------------------------------------------
            // 03.01.获取Json数据 ( tablePage 当前页  pageSize 分页条数  quickSearch 快捷搜索  arraySearch 更多搜索 )
            getTableJson() {
                this.arraySearch.quick_search = this.quickSearch
                this.arraySearch.table_page = this.tablePage
                this.arraySearch.page_size = this.pageSize
                this.$api.get('/api/get/basics-array/', this.arraySearch).then((response) => {
                    this.tableData = response.data
                    this.pageSize = response.page_size
                    this.tableTotal = response.table_total
                    this.tablePage = response.table_page
                    this.tableLoading = false
                })
            },
            // 03.02.分页栏目 - 分页数
            changeSize(val) {
                // 01.赋值分页数
                this.pageSize = val
                // 02.获取Json数据
                this.getTableJson()
            },
            // 03.03.分页栏目 - 跳转页
            changeCurrent(val) {
                // 01.赋值跳转页
                this.tablePage = val
                // 02.获取Json数据
                this.getTableJson()
            },
            // 03.04.上级字典 - 数据集
            getParentArray() {
                this.$api.get('/api/get/parent-basics-array/').then((response) => {
                    this.parentData = response.data
                })
            },
            // 04.搜索/查询操作 ------------------------------------------------
            // 04.01.快捷搜索/查询
            clickQuickSearch() {
                // 01.获取Json数据
                this.getTableJson()
            },
            // 04.02.搜索/查询 - 查询提交
            clickArraySearch() {
                // 01.获取Json数据
                this.getTableJson()
                this.searchState = false
            },
            // 04.03.搜索/查询 - 重置Form表单
            resetArraySearch() {
                this.$refs['arraySearch'].resetFields()
                this.getTableJson()
                this.searchState = false
            },
        },
        // 生命周期 - 挂载完成
        mounted() {
            // 01.获取Json数据
            this.getTableJson()
            // 03.04.上级权限 - 数据集
            this.getParentArray()
        },
    }
</script>
